import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
    baseURL: API,
});

// Attach bearer token if present in localStorage
api.interceptors.request.use((config) => {
    const t = localStorage.getItem("ebg_token");
    if (t) {
        config.headers = config.headers || {};
        config.headers.Authorization = `Bearer ${t}`;
    }
    return config;
});

export function formatApiError(err) {
    const d = err?.response?.data?.detail;
    if (d == null) return err?.message || "Something went wrong.";
    if (typeof d === "string") return d;
    if (Array.isArray(d)) return d.map((e) => (e && e.msg) || JSON.stringify(e)).join(", ");
    if (d?.msg) return d.msg;
    return String(d);
}
